module.exports = __webpack_public_path__ + "img/V-R-2-unload-connect-shadow.e2b3c907.png";